import axios from "axios";
import { getToken } from "./get-token"; // Change to a regular function

const http_payroll = axios.create({
  baseURL: "/api",
  // baseURL: process.env.REACT_APP_API_BASE_URL_DEMO,
  // baseURL: process.env.REACT_APP_API_BASE_URL_LIVE,
  timeout: 30000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  withCredentials: true,
  // credentials: "include",
  secure: false,
});

http_payroll.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // 🔐 Cookie expired or invalid
      localStorage.clear();
      sessionStorage.clear();

      window.location.href = "/Login"; // auto logout
    }

    return Promise.reject(error);
  }
);

// Change request data/error here
// http_payroll.interceptors.request.use(
//   (config) => {
//     const token = getToken(); // Use the regular function
//     config.headers.Authorization = `Bearer ${token ? token : ""}`;
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

export default http_payroll;

// Working Final Version

// import axios from 'axios';
// // import { getToken } from './get-token';

// const http_payroll = axios.create({

//   baseURL: 'http://18.138.222.35:416/payrollsystem/microservices/v2',
//   timeout: 30000,
//   headers: {Authorization: 'Basic d2luYXBwOmFkbWlu'}
// //   headers: {
// //     Accept: 'application/json',
// //     'Content-Type': 'application/json',
// //   },
// });

// // // Change request data/error here
// // http.interceptors.request.use(
// //   (config) => {
// //     // const token = getToken();
// //     // config.headers.Authorization = {
// //     //   ...config.headers,
// //     //   Authorization: `Bearer ${token ? token : ''}`,
// //     // };
// //     config.headers.Authorization = `Bearer ${token ? token : ''}`;
// //     return config;
// //   },
// //   (error) => {
// //     return Promise.reject(error);
// //   }
// // );

// export default http_payroll;
